// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../../pplx/frontend/api-clients/core/client.js';
export const browserInvitesClient = createTypedClient();
export const createBrowserInvitesClient = (config) => createTypedClient(config);
